import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiBaseURL } from "../common/Helper";
import { LocalStorage } from "../common/Localstorage";
import { ResponseModel } from "../models/ResponseModel";
import { ServerProductQuote } from "../models/ServerProductQuoteModel";

export const serverProductsAPI = createApi({
  reducerPath: "serverProductsAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: apiBaseURL + "server-products/",
    prepareHeaders: (headers) => {
      const token = LocalStorage.getToken();
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getServerProducts: builder.query<
      ResponseModel,
      { limit: number; page: number; countryId: number; keyword: string }
    >({
      query: (params) => {
        return `get-all?countryId=${params.countryId}&limit=${params.limit}&page=${params.page}${`&keyword=${params.keyword}`}`;
      },
    }),
    getServerProduct: builder.query<ResponseModel, { productId: number }>({
      query: (params) => {
        return "get/" + params.productId;
      },
    }),
    submitQuote: builder.mutation<
      ResponseModel,
      {
        productId: number;
        customerName: string;
        email: string;
        phone?: string;
        quantity: number;
        selectedOptions: { [key: string]: any };
      }
    >({
      query: (params) => ({
        url: "submit-quote",
        method: "POST",
        body: params,
      }),
    }),
    getServerQuotes: builder.query<
      ResponseModel,
      { limit: number; page: number }
    >({
      query: (params) => {
        return `quotes/get-all?limit=${params.limit}&page=${params.page}`;
      },
    }),
    updateQuote: builder.mutation<
      ResponseModel,
      {
        id: number;
        estimatedPrice?: number;
        actualPrice?: number;
        status?: string;
        comments?: string;
        options?: {
          id?: number;
          serverOptionId?: number;
          quantity: number;
        }[];
      }
    >({
      query: (params) => ({
        url: `quotes/${params.id}`,
        method: "PUT",
        body: {
          estimated_price: params.estimatedPrice,
          actual_price: params.actualPrice,
          status: params.status,
          comments: params.comments,
          options: params.options,
        },
      }),
    }),

    // 🔥 DELETE QUOTE (soft delete)
    deleteQuote: builder.mutation<ResponseModel, { id: number }>({
      query: ({ id }) => ({
        url: `quotes/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetServerProductsQuery,
  useGetServerProductQuery,
  useSubmitQuoteMutation,
  useGetServerQuotesQuery,
  useUpdateQuoteMutation,
  useDeleteQuoteMutation,
} = serverProductsAPI;
